module.exports = __webpack_public_path__ + "static/whitebib-d423b06ee03c96cf18985dbb22ad32dd.png";